
import { ENDPOINTS } from "../../constants";
import axios from "axios";
import { BACKEND_URL } from "../../_configs";
import projects from './kccpad.json'


export const getProjects = async()=>{
  return projects
  // try {
  //   const result = await axios.get(
  //     `${BACKEND_URL}${ENDPOINTS.GET_PROJECTS}`
  //   );
  //   console.log(result);
  //   if (result.status === 200) {
  //     return result.data;
  //   }

  //   return [];
  // } catch (error) {
  //   const response = error.response;

  //   console.log(response);
  //   //    return response

  //   return [];
  // }
}

export const getProject = async (contract) => {
  const project =  projects.find(project => project.contract === contract)
  return {
    status: 200,
    data: project
  }
  // try {
  //   const result = await axios.get(
  //     `${BACKEND_URL}${ENDPOINTS.GET_PROJECT_DETAILS.replace(':id', contract)}`
  //   );
  //   if (result.status === 200) {
  //     return {
  //       status: 200,
  //       data: result.data
  //     }
  //   } else {
  //     return {
  //       status: 404,
  //       data: null
  //     }
  //   }
  // } catch (error) {
  //   const response = error.response;

  //   console.log(response);

  //   return {
  //     status: 404,
  //     data: null
  //   }
  // }
}
